import DtoReferencial from './DtoReferencial'

export default class DtoAltimetrySystemAltimetrySystem extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
